import { useParams } from 'react-router-dom';
import { findSectionSpec } from './sections';
import { usePlanFeatures } from '@/hooks/usePlanFeatures';
import { PlanFeatureLocked } from '@/components/subscription/PlanFeatureLocked';

/**
 * Renders whichever section the `:section` param names.
 *
 * One route entry rather than nineteen: the sections differ only in which
 * component they mount, and that mapping already lives in `sections.tsx`. The
 * layout has validated the param and the permission before this renders.
 */
export function SettingsSectionRoute() {
  const { section } = useParams();
  const { has } = usePlanFeatures();
  const spec = findSectionSpec(section);
  if (!spec) return null;
  if (!has(spec.feature)) return <PlanFeatureLocked feature={spec.feature!} />;
  const Section = spec.component;
  return <Section />;
}
